// extracted by mini-css-extract-plugin
export default {"calendarPage":"CalendarPage_calendarPage__3zCex"};